import React, { useState, useEffect, Fragment, useLayoutEffect } from 'react';
import Grid from "@mui/material/Grid";
// import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import LoadingButton from '@mui/lab/LoadingButton';
import EastIcon from "@mui/icons-material/East";
import { FormControl, MenuItem, InputLabel, Select, Autocomplete } from "@mui/material";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import moment from 'moment';
import { getCarbrand, getCarmodel } from '../APImaster';    // getProvince, getAmphur, 
import { SaveImage } from '../API';

import { useForm } from "react-hook-form";

import Webcam from "react-webcam";

import CameraComponent from '../CameraComponent';
import CameraComponent3 from '../CameraComponentV3';
import CameraSuperSurvey from '../CameraSuperSurvey';   //// test
import PhotoCamera from "@mui/icons-material/PhotoCamera";
import { styled } from "@mui/material";

import CircularProgress from '@mui/material/CircularProgress';

// console.log(window.location)
const windowUrl = window.location.search;
// console.log(windowUrl)
const params = new URLSearchParams(windowUrl);
// console.log(params)
const encodedcID = params.get('_c')
// console.log(encodedcID) // Qk9EMjAyMjA5LTEyNjAz
  // // Decode the String
  var caseID = atob(encodedcID);
  // console.log(caseID); // Outputs: 138
const windowWidth = window.innerWidth;
const windowHeight = window.innerHeight;
let loadingSize = 40;
    if(windowWidth > windowHeight){ 
        loadingSize = windowHeight*0.75; 
    } else{ 
        loadingSize = windowWidth*0.75; 
    }

const Img = styled("img")({
    margin: "auto",
    display: "block",
    maxWidth: "100%",
    height: 160,
});

const FACING_MODE_USER = { facingMode: 'user' }; // Front Camera
const FACING_MODE_ENVIRONMENT = { facingMode: { exact: 'environment' } }; // Back Camera

const CarInfoItems = [
  { id: 1, displayFormat: 'B', name: 'ถ่ายรูปเลขไมล์' },
  // { id: 2, name: 'เลขไมล์2', image: 'assets/aaa.png' },
  // { id: 3, name: 'เลขไมล์3', image: 'assets/aaa.png' },
  // { id: 4, name: 'เลขไมล์4', image: 'assets/aaa.png' },
  // { id: 5, name: 'เลขไมล์5', image: 'assets/aaa.png' },
];
// ถ้าเกิน 3 เอาแถวละ 3 ถ้าไม่ถึง 3 ขยายให้เต็มบรรทัด
const itemsCount = CarInfoItems.length>3?3:CarInfoItems.length;
const itemsCol = Math.floor(12/itemsCount);

export default function CarInfoForm({ onSave, initalData, dataStep, btnLoading }) {
    const [gender, setGender] = useState("");
    const [image, setImage] = useState(null);
    const webcamRef = React.useRef(null);
    const [videoConstraints, setVideoConstraints] = useState(FACING_MODE_ENVIRONMENT);
    const [loading, setLoading] = React.useState(false);

    const { register, formState: { errors }, handleSubmit, setValue, reset } = useForm({});
    // const { register, formState: { errors }, handleSubmit, setValue } = useForm({});
    const [previousData, setPreviousData] = useState(null);

    const [imageSrc, setImageSrc] = useState(null);
    const [capturedImages, setCapturedImages] = useState(null);

    const [carbrand, setCarbrand] = useState("");
    const [carbrand_desc, setCarbrandDesc] = useState("");
    const [carbrandList, setCarbrandList] = useState([]);
    const [carmodel, setCarmodel] = useState("");
    const [carmodel_desc, setCarmodelDesc] = useState("");
    const [carmodelList, setCarmodelList] = useState([]);
    const [carmodelFullList, setCarmodelFullList] = useState([]);

    // const ref = React.useRef();

      const getListOfVideoInputs = async () => {
        const mediaDevices = await navigator.mediaDevices.enumerateDevices();
        return mediaDevices.filter(device => device.kind === 'videoinput');
      };

      const switchCamera = async () => {
        const videoInpuList = await getListOfVideoInputs();
        if (videoInpuList.length > 1) {
          const currentVideoConstraints = { ...videoConstraints };

          if (JSON.stringify(currentVideoConstraints) === JSON.stringify(FACING_MODE_USER)) {
            setVideoConstraints(FACING_MODE_ENVIRONMENT);
          } else {
            setVideoConstraints(FACING_MODE_USER);
          }
        } else {
          alert('Device has only one camera.');
        }
      };

      const capture = React.useCallback(() => {
        const imageSrc = webcamRef.current.getScreenshot();
        setImage(imageSrc);
      }, [webcamRef, setImage]);

      const retake = () => setImage(null);

      const upload = () => {
        alert('Your photo uploaded successfully!');
        setImage(null);
      };

    // useEffect(() => {
    //     getData();
    // }, []);

    useEffect(() => {
        // console.log("useEffect");
            // ref.current = 'some value';
            // console.log("useEffect",ref.current);
        // reset form with previousData data
        reset(previousData);
        
        // const newImages = ['https://upload.wikimedia.org/wikipedia/commons/1/11/Test-Logo.svg']
        // setCapturedImages(newImages)



            // var MTdata = JSON.parse(localStorage.getItem('masterdata'));
            // var MTcarbrand = JSON.parse(localStorage.getItem('carbrand'));

                        // console.log("MTdata", typeof(MTdata), MTdata);
                        // console.log("MTdata parse", typeof(JSON.parse(MTdata)), JSON.parse(MTdata));

                        // var c = JSON.parse(MTdata);
                        // console.log("c", typeof(c), c);

                        // console.log("MTcarbrand", typeof(MTcarbrand), MTcarbrand);
                        // console.log("MTcarbrand", typeof(MTcarbrand), JSON.parse(MTcarbrand));

        // get Carbrand
            var MTcarbrand = JSON.parse(localStorage.getItem('carbrand'));
            if(MTcarbrand){
                // console.log("MT carbrand if");
                setCarbrandList(MTcarbrand);
            }else{
                // console.log("MT carbrand else");
                getCarbrand().then(response => {
                    if (response && response.status === 200) {
                        // localStorage.removeItem("masterdata"); 
                        var a = JSON.stringify(response.data);
                        var b = JSON.parse(a);
                        // console.log("mad test", b );
                        // localStorage.setItem("masterdata", a); 
                        localStorage.setItem("carbrand", a);

                        setCarbrandList(response.data);
                    }
                })
            }

        // get Carmodel
            var MTcarmodel = JSON.parse(localStorage.getItem('carmodel'));
            if(MTcarmodel){
                // console.log("MT carmodel if");
                setCarmodelFullList(MTcarmodel);
            }else{
                // console.log("MT carmodel else");
                getCarmodel().then(response => {
                    if (response && response.status === 200) {
                        // localStorage.removeItem("masterdata"); 
                        var a = JSON.stringify(response.data);
                        var b = JSON.parse(a);
                        // console.log("mad test", b );
                        // localStorage.setItem("masterdata", a); 
                        localStorage.setItem("carmodel", a);
                        MTcarmodel = a;

                        setCarmodelFullList(response.data);
                    }
                })
            }
            if(previousData){
                // console.log("previousData", previousData);
                setCarbrand(previousData.car_brand);
                carbrandList.map((item) => {
                    // console.log("item",item);
                    if(item.cbrand_name_en == previousData.car_brand){
                        // console.log("previousData cbrand_name_en value ", item.cbrand_name_en);
                        setCarbrandDesc(item.cbrand_name_en);
                    }
                })
                // console.log("MTcarmodel", MTcarmodel);
                if(previousData.car_brand && MTcarmodel){   // ==> เขียนถูกเปล่าไม่รู้
                    // OnChangeCarbrand(previousData.car_brand);
                    OnPreSetCarbrand(MTcarmodel, previousData.car_brand, previousData);

                    //// ย้ายท่อนด้านล่าง ไปไว้ใน function OnPreSetCarbrand ////
                    //// ==> เหมือนว่า carmodelList ใน function มันจะ update ทีหลัง ////
                    // setCarmodel(previousData.car_model);
                    // // setCarmodelDesc(previousData.car_model_desc);
                    // console.log("previousData.car_model", previousData.car_model);
                    // carmodelList.map((item) => {
                    // console.log("item",item);
                    //     if(item.carmodelID == previousData.car_model){
                    //         console.log("previousData modelname_en value ", item.modelname_en);
                    //         setCarmodelDesc(item.modelname_en);
                    //     }
                    // })
                }
            }


    }, [previousData]);

    useLayoutEffect(() => {
        // console.log("useLayoutEffect");
            // console.log("useLayoutEffect",ref.current);
        getData();
        //this runs before render
        // console.log("useLayoutEffect");
        // console.log("imageSrc",dataStep.imageSrc);
        // console.log("capturedImages",dataStep.capturedImages);
    }, []);

    const onSubmit = (data) => {
        // console.log("page data",data);
        // console.log("imageSrc",data.imageSrc);

            // if(carmodel !== ""){
            //     console.log("if carmodel", carmodel);
            // }else{
            //     console.log("else carmodel");
            //     data.car_model = "";
            // }

            if(carbrand_desc){
                // console.log("carbrand_desc if");
                data.car_brand_desc = carbrand_desc;
            }else{
                // console.log("carbrand_desc else");
            }
            // console.log("onSubmit car_model", carmodel);
            if(carmodel == ""){
                data.car_model = "";
                data.car_model_desc = "";
            }else{
                if(carmodel_desc){
                    // console.log("carmodel_desc if");
                    data.car_model_desc = carmodel_desc;
                }else{
                    // console.log("carmodel_desc else");
                }
            }

            // // console.log("capturedImages[0]", capturedImages[0]);
            // if(!capturedImages[0]){
            //     // console.log("if");
            //     alert("กรุณาถ่าย หรือ อัพโหลด รูปเลขไมล์ ก่อนไปยังขั้นตอนถัดไป");
            //     return;
            // }

            // console.log("data.carbrand_desc", data.car_brand_desc);
            // console.log("data.carmodel_desc", data.car_model_desc);

        onSave(data);
    };
    
    // const onSubmit_autocomplete = (data) => {   // กรณี autocomplete มันจะต้องเอาค่ามาใส่ก่อนส่งไป sumbit
    //     // console.log("page data",data);
    //     data.car_brand = carbrand;
    //     data.car_model = carmodel;
    //     onSave(data);
    // };

    function getData() {
        // console.log("getData",dataStep);
        if (dataStep !== "") {
            // console.log("dataStep info",dataStep);
            setPreviousData({
                plate_no: dataStep.plate_no,
                ref_no: dataStep.ref_no,
                customer_name: dataStep.customer_name,
                // customer_lastname: dataStep.customer_lastname,
                car_brand: dataStep.car_brand,
                car_model: dataStep.car_model,
                car_brand_desc: dataStep.car_brand_desc,
                car_model_desc: dataStep.car_model_desc,
                mileage: dataStep.mileage,
                // imageSrc: dataStep.imageSrc,
                capturedImages: dataStep.capturedImages,
            })
            // setImageSrc(dataStep.imageSrc);
            setCapturedImages(dataStep.capturedImages);

                // console.log("carbrandList", carbrandList);
                carbrandList.map((item) => {
                    if(item.cbrand_name_en === dataStep.car_brand){
                        // console.log("dataStep.car_brand ", item.cbrand_name_en);
                        setCarbrandDesc(item.cbrand_name_en);
                    }
                })
                    // console.log("carmodelList", carbrandList);
                    carmodelList.map((item) => {
                        if(item.carmodelID === dataStep.car_model){
                            // console.log("dataStep.car_model ", item.modelname_en);
                            setCarmodelDesc(item.modelname_en);
                        }
                    })

            // setCarbrand(dataStep.car_brand);
            // if(dataStep.car_brand){
            //     OnChangeCarbrand(dataStep.car_brand);
            //     setCarmodel(dataStep.car_model);
            // }
    //         console.log(dataStep);
    //         setIs_punish(dataStep.is_punish !== null ? dataStep.is_punish : "0");
    //         setGender(dataStep.gender);
    //         setBirthday(dataStep.birthday);
    //         setEducation_qual(dataStep.education_qual);
        }else{  // set initalData
            // console.log("initalData",initalData);
            if(initalData.length !== 0){    // ลองทำ save/load แบบแยก tab
                // console.log("initalData if");
                // console.log("initalData", typeof(initalData));
                    let noitfyData = initalData.notify[0];
                    // console.log("noitfyData", noitfyData);
                setPreviousData({
                    plate_no: noitfyData.plate_no,
                    ref_no: noitfyData.ref_no,
                    customer_name: noitfyData.customer_name,
                    // customer_lastname: noitfyData.customer_lastname,
                    car_brand: noitfyData.car_brand,
                    car_model: noitfyData.car_model,
                    car_brand_desc: noitfyData.car_brand_desc,
                    car_model_desc: noitfyData.car_model_desc,
                    mileage: noitfyData.mileage,
                    // imageSrc: noitfyData.imageSrc,
                    capturedImages: noitfyData.capturedImages,
                })
            }else{
                // console.log("initalData else");
            }
        }
    }
    const handleCapture = (capturedImages) => {
        console.log("on parent Capture handleCapture",capturedImages);
        // this.setState({language: langValue});

        // register('t1.test', '1');    // save t1.test to form data
        // setValue('imageSrc', imageSrc);
        setValue('capturedImages', capturedImages);
        setCapturedImages(capturedImages);
    }

    const handleRemoveImage = (index, newImages) => {
        // console.log("handleRemoveImage index", index, "newImages", newImages);
        setValue('capturedImages', newImages);
        setCapturedImages(newImages);
    }

    const handleSaveImage = (base64Image) => {
        // console.log("handle SaveImage base64Image", base64Image);
        let sendData = new FormData();
            sendData.append('image', base64Image);
            sendData.append('caseID', caseID);
            sendData.append('img_type', "MILE");
        setLoading(true);
        // ## saveImageAPI(sendData); ##
        SaveImage(sendData).then(response => {
            // console.log("response saveImageAPI", response);
            setLoading(false);
            if (response && response.status === 200) {
                // setLoading(false);
                ////// update url to current state //////
                console.log("response",response.data.url);
                let imageUrl = response.data.url[0];
                console.log("imageUrl",imageUrl);
                setValue('capturedImages', imageUrl);
                setCapturedImages(imageUrl);

            }else if (response && response.data){
                ////// do something alert ? //////
                console.log("API response error ["+ response.status + "]", response.data.message);
            }else{
                console.log("API response error", response);
            }
        })
    }

    const OnChange_Carbrand = (value) => {
        console.log("OnChange_Carbrand", value);
        if(value){
            console.log("value", value.cbrand_name_en);
            setCarbrand(value.cbrand_name_en);
            OnChangeCarbrand(value.cbrand_name_en);
        }
    }

    const OnChangeCarbrand = (value) => {
        // console.log("OnChangeCarbrand value", value);

        // console.log("carmodelFullList",carmodelFullList);
        var cmodel = [];
        carmodelFullList.map((item) => {
            if(item.brand === value){
                // console.log("item",item);
                cmodel.push({'carmodelID': item.carmodelID, 'modelname_en': item.modelname_en})
            }
        }) 
        // console.log("cmodel",cmodel);
        setCarmodelList(cmodel);
        setCarmodel("");
        setCarmodelDesc("");

      // const { id, value } = e.target;
      // // setDamage_detail(value);
      // console.log("OnChangeCarbrand value", value);

      //   // console.log("OnChangeCarbrand value", value);
      //   // setValue('capturedImages', newImages);
      //   // setCapturedImages(newImages);

        // this.state.carmodel.map((item) => {
        //     if(item.cbrandID === value){
        //         // console.log("item",item);
        //         cmodel.push({'carmodelID': item.carmodelID, 'modelname_en': item.modelname_en})
        //     }
        // }) 
    }

    const OnPreSetCarbrand = (carmodel_fullList, value, previousData) => {
        // console.log("OnPreSetCarbrand value", value);

        // console.log("carmodel_fullList",carmodel_fullList);
        var cmodel = [];
        carmodel_fullList.map((item) => {
            if(item.brand == value){
                // console.log("item",item);
                cmodel.push({'carmodelID': item.carmodelID, 'modelname_en': item.modelname_en})
            }
        }) 
        // console.log("cmodel",cmodel);
        // console.log("cmodel length",cmodel.length);
        setCarmodelList(cmodel);
        setCarmodel("");
        setCarmodelDesc("");

        if(cmodel.length > 0){
            setCarmodel(previousData.car_model);
            // setCarmodelDesc(previousData.car_model_desc);
            // console.log("previousData.car_model", previousData.car_model);
            cmodel.map((item) => {
            // console.log("item",item);
                if(item.carmodelID == previousData.car_model){
                    // console.log("item",item);
                    // console.log("previousData modelname_en value ", item.modelname_en);
                    setCarmodelDesc(item.modelname_en);
                }
            })
        }

    }



    return (
        <React.Fragment>
        {
            loading ? <CircularProgress size={loadingSize} />
            : <form onSubmit={handleSubmit(onSubmit)}>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            {...register("plate_no")}
                            aria-invalid={errors.plate_no ? "true" : "false"}
                            fullWidth
                            id="plate_no"
                            label="ทะเบียนรถ"
                            InputLabelProps={{ shrink: true, sx: { zIndex: 'auto' } }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            {...register("ref_no")}
                            aria-invalid={errors.ref_no ? "true" : "false"}
                            fullWidth
                            id="ref_no"
                            label="เลขที่อ้างอิง"
                            InputLabelProps={{ shrink: true, sx: { zIndex: 'auto' } }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <TextField
                            {...register("customer_name")}
                            aria-invalid={errors.customer_name ? "true" : "false"}
                            fullWidth
                            id="customer_name"
                            label="ชื่อลูกค้า-นามสกุล"
                            InputLabelProps={{ shrink: true, sx: { zIndex: 'auto' } }}
                        />
                    </Grid>
                    {/*<Grid item xs={12} sm={6}>
                        <TextField
                            {...register("customer_lastname")}
                            aria-invalid={errors.customer_lastname ? "true" : "false"}
                            fullWidth
                            id="customer_lastname"
                            label="นามสกุล"
                            InputLabelProps={{ shrink: true, sx: { zIndex: 'auto' } }}
                        />
                    </Grid>*/}


                        {/* test - Autocomplete
                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth={true}>
                            <Autocomplete
                              disablePortal
                                {...register("car_brand")}
                              options={carbrandList}
                              getOptionLabel={(option) => option.cbrand_name_en || "" }
                              // sx={{ width: 300 }}
                              renderInput={(params) => <TextField {...params} label="ยี่ห้อ" />}
                              value={{ cbrand_name_en: carbrand }}
                              isOptionEqualToValue={(option, value) => option.cbrand_name_en === value.cbrand_name_en}
                              // defaultValue={{ cbrand_name_en: carbrand }}
                              onChange={(event, values) => {
                                console.log("OnChange Carbrand new event", event.target, values);
                                OnChange_Carbrand(values)   // set car brand ข้างในนี้
                              }}
                            />
                        </FormControl>
                    </Grid> */}

                    {/*  */}
                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth={true}>
                            <TextField
                                {...register("car_brand")}
                                id="car_brand"
                                select
                                label="ยี่ห้อ"
                                value={carbrand}
                                InputLabelProps={{ sx: { zIndex: 'auto' } }}
                                onChange={(event) => {
                                    // console.log("OnChangeCarbrand event", event);
                                    setCarbrand(event.target.value)
                                        {
                                            carbrandList.map((item) => {
                                                if(item.cbrand_name_en === event.target.value){
                                                    // console.log("cbrand_name_en value ", item.cbrand_name_en);
                                                    setCarbrandDesc(item.cbrand_name_en);
                                                }
                                            })
                                        }
                                    setCarmodel('');
                                    // console.log("value ", event.target.value);
                                    setCarmodelDesc('');
                                    // getAmphur(event.target.value)
                                    OnChangeCarbrand(event.target.value)
                                }}
                            >
                                {carbrandList.map(item =>
                                    <MenuItem value={item.cbrand_name_en} key={item.cbrand_name_en}>{item.cbrand_name_en}</MenuItem>
                                )}
                            </TextField>
                        </FormControl>
                    </Grid>

                    {/*<Grid item xs={12} sm={6}>
                        <TextField
                            {...register("car_brand")}
                            aria-invalid={errors.car_brand ? "true" : "false"}
                            fullWidth
                            id="car_brand"
                            label="ยี่ห้อ"
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>*/}


                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth={true}>
                            <TextField
                                {...register("car_model")}
                                id="car_model"
                                select
                                label="รุ่น"
                                value={carmodel}
                                InputLabelProps={{ sx: { zIndex: 'auto' } }}
                                onChange={(event) => {
                                    // console.log("car_model change", event.target);
                                    setCarmodel(event.target.value)
                                    // setCarmodelDesc(event.target.value)
                                        {
                                            carmodelList.map((item) => {
                                                if(item.carmodelID === event.target.value){
                                                    // console.log("modelname_en value ", item.modelname_en);
                                                    setCarmodelDesc(item.modelname_en);
                                                }
                                            })
                                        }
                                }}
                            >
                                {carmodelList.map(item =>
                                    <MenuItem key={item.modelname_en} value={item.modelname_en}>{item.modelname_en}</MenuItem>
                                )}
                            </TextField>
                        </FormControl>
                    </Grid>


                    {/*<Grid item xs={12} sm={6}>
                        <TextField
                            {...register("car_model")}
                            aria-invalid={errors.car_model ? "true" : "false"}
                            fullWidth
                            id="car_model"
                            label="รุ่น"
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>*/}



                    {/*<Grid item xs={12} sm={6}>
                        <TextField
                            {...register("chassis_no")}
                            aria-invalid={errors.chassis_no ? "true" : "false"}
                            fullWidth
                            id="chassis_no"
                            label="เลขตัวถัง"
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>*/}
                    {/*<Grid item xs={12} sm={6}>
                        <TextField
                            {...register("mileage")}
                            aria-invalid={errors.mileage ? "true" : "false"}
                            fullWidth
                            id="mileage"
                            label="เลขไมล์"
                            type="number"
                            InputLabelProps={{ 
                                shrink: true, 
                                // sx: { color: "red", "&.Mui-focused": { color: "green" } },
                                sx: { zIndex: 'auto' }, 
                            }}
                            // style={{ zIndex: 'auto' }}
                        />
                    </Grid>*/}


                    <CameraComponent items={CarInfoItems} itemsCol={itemsCol} 
                        displayFormat='B'   // A: cannot capture with vertical layout
                        onCapture={handleCapture}
                        onRemoveImage={handleRemoveImage}
                        onSaveImage={handleSaveImage}
                        // previousData={dataStep.imageSrc?dataStep.imageSrc:null}
                        previousData={dataStep.capturedImages?dataStep.capturedImages:null}
                        uploadAble={false}
                    />
                    {/*<CameraComponent3 items={CarInfoItems} itemsCol={itemsCol} 
                        displayFormat='B'   // A: cannot capture with vertical layout
                        onCapture={handleCapture}
                        onRemoveImage={handleRemoveImage}
                        // previousData={dataStep.imageSrc?dataStep.imageSrc:null}
                        previousData={dataStep.capturedImages?dataStep.capturedImages:null}
                        uploadAble={false}
                    />*/}


                    {/*<CameraSuperSurvey items={CarInfoItems} itemsCol={itemsCol}
                        onCapture={handleCapture}
                        onRemoveImage={handleRemoveImage}
                        // previousData={dataStep.imageSrc?dataStep.imageSrc:null}
                        previousData={dataStep.capturedImages?dataStep.capturedImages:null}
                        uploadAble={false}
                    />*/}

                            {/*<Grid container spacing={2}>
                                <Grid item md={12} sm={12} xs={12}>
                                    <Button color="primary" variant="outlined"
                                        aria-label="upload picture" component="label"
                                        sx={{ width: "100%", minHeight: 170, maxHeight: 170, }}
                                    >
                                        <input type="file" accept="image/*"
                                            hidden capture 
                                            onChange={handleCapture}
                                        />
                                        {/*capturedImages.length > 0 ? (
                                            capturedImages.map((item) => (<Img src={item} />))
                                        ) : (
                                            <PhotoCamera sx={{ fontSize: 60 }} />
                                        )}
                                    </Button>
                                </Grid>
                            </Grid>*/}
        



        {/*<div className="camera-container" style={{ position: 'relative', width: '100%', maxWidth: '400px', aspectRatio: '4/3' }}>
          {image ? (
            <img src={image} alt="Captured" style={{ width: '100%', height: 'auto' }} />
          ) : (
            <div style={{ position: 'relative' }}>
              <Webcam
                audio={false}
                ref={webcamRef}
                screenshotFormat="image/jpeg"
                videoConstraints={videoConstraints}
                style={{ width: '100%', height: 'auto' }}
              />
            </div>
          )}
        </div>*/}

                    

                </Grid>
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                    }}
                >
                    {/*<button
                        className="btn btn-primary"
                        type="submit"
                        // endIcon={<EastIcon />}
                        style={{marginTop:'24px',marginLeft:'8px',backgroundColor:'#1565c0'}}
                    >
                        ถัดไป <EastIcon />
                    </button>*/}
                    
                    <LoadingButton
                        variant="contained"
                        type="submit"
                        endIcon={<EastIcon />}
                        // sx={{ mt: 3, ml: 1, position: 'static' }}
                        // เดิมของ MUI เป็น position: 'relative' แล้วมันไปทับกับ position ของกล้อง
                        loading={btnLoading}
                        loadingPosition="start"
                    >
                        ถัดไป
                    </LoadingButton>

                    {/*
                    <Button onClick={handleBack} sx={{ mt: 3, ml: 1 }}>
                        ย้อนกลับ
                    </Button>

                    <LoadingButton
                        type="submit"
                        loading={isLoading}
                        loadingPosition="end"
                        endIcon={<EastIcon />}
                        variant="contained"
                        sx={{ mt: 3, ml: 1 }}
                    >
                        สมัคร
                    </LoadingButton> 
                    */}
                    
                </Box>
            </form>
        }
        </React.Fragment>
    );
}
